import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CplCycle } from '../../model/cpl-cycle.model';
import { CplItem } from '../../model/cpl-item.model';
import { VerificationHistory } from '../../model/cpl-verification-history.model';
import { ComplianceItemHelpersService } from '../../services/compliance-item-helpers/compliance-item-helpers.service';
import { VerifyService } from 'src/app/services/verify.service';
import { SessionService } from '@edl-development/edl-common';
import { AccessRoleHelper } from 'src/app/model/helpers/access-role.helper';
import { firstValueFrom } from 'rxjs';

@Component({
    selector:    'user-cycle-summary',
    templateUrl: './user-cycle-summary.component.html',
    styleUrls: ['../../../css/shared-styles/history-item-container.scss', './user-cycle-summary.component.scss']
})
export class UserCycleSummary implements OnInit { 
    @Input() userCycle: CplCycle;
    @Input() complianceItem: CplItem;
    @Input() isUser: boolean = false;

    @Output() onSubmissionComplete = new EventEmitter();

    verificationHistory  = Array<VerificationHistory>();

    constructor(
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private verifyService: VerifyService,
        private sessionService: SessionService
    ) {}

    ngOnInit() {
        (this.complianceItemHelpersService.isSupervisorView(this.isUser) ?
            firstValueFrom(this.verifyService.getVerifyHistoryForSupervisors(this.userCycle.CycleID)) :
            firstValueFrom(this.verifyService.getVerifyHistoryForEndUser(this.userCycle.CycleID))
        ).then((result: Array<VerificationHistory>) => {
            this.verificationHistory = result;
        });
    }

    onMessagesClicked() {
        this.onSubmissionComplete.emit();
    }
}